"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Text_1 = __importDefault(require("shared/components/Text"));
var FloatingWrapper = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        display: 'inline-block',
        textAlign: 'center',
        width: 350,
        background: theme.palette.common.white,
        zIndex: 2,
        padding: theme.spacing(4, 2),
        borderRadius: 10,
        boxShadow: '2px 2px 8px 0 rgb(0 0 0 / 12%)',
        transform: 'translate(-50%, -50%)',
    });
});
var StyledTable = (0, styles_1.styled)('table')(function (_a) {
    var theme = _a.theme;
    return ({
        borderCollapse: 'separate',
        border: '1px solid rgb(208, 217, 223)',
        borderRadius: 6,
        width: '100%',
        borderSpacing: 0,
        margin: theme.spacing(2, 0),
        filter: 'blur(4px)',
        '& td, & th': {
            padding: theme.spacing(2),
        },
    });
});
var SampleData = function (_a) {
    var onClick = _a.onClick, isSending = _a.isSending;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ position: "relative", height: "100%", width: "100%", mt: 4, id: "requested" }, { children: [(0, jsx_runtime_1.jsxs)(FloatingWrapper, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, fontWeight: 600, mb: 2 }, { children: "Discover how you can save for this tool" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ size: "large", onClick: onClick, isSending: isSending }, { children: "Request Access" }))] }), (0, jsx_runtime_1.jsxs)(StyledTable, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: "Date" }), (0, jsx_runtime_1.jsx)("th", { children: "Main Plan" }), (0, jsx_runtime_1.jsx)("th", { children: "Qty" }), (0, jsx_runtime_1.jsx)("th", { children: "Unit Price / m" }), (0, jsx_runtime_1.jsx)("th", { children: "Billing" }), (0, jsx_runtime_1.jsx)("th", { children: "Currency" }), (0, jsx_runtime_1.jsx)("th", { children: "Total" })] }) }), (0, jsx_runtime_1.jsxs)("tbody", { children: [(0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: "2022-01" }), (0, jsx_runtime_1.jsx)("td", { children: "Enterprise" }), (0, jsx_runtime_1.jsx)("td", { children: "100" }), (0, jsx_runtime_1.jsx)("td", { children: "18.76" }), (0, jsx_runtime_1.jsx)("td", { children: "Annual" }), (0, jsx_runtime_1.jsx)("td", { children: "AUD" }), (0, jsx_runtime_1.jsx)("td", { children: "$5,400" })] }), (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: "2021-11" }), (0, jsx_runtime_1.jsx)("td", { children: "Enterprise" }), (0, jsx_runtime_1.jsx)("td", { children: "15" }), (0, jsx_runtime_1.jsx)("td", { children: "20.00" }), (0, jsx_runtime_1.jsx)("td", { children: "Quarterly" }), (0, jsx_runtime_1.jsx)("td", { children: "USD" }), (0, jsx_runtime_1.jsx)("td", { children: "$1,300" })] }), (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: "2021-03" }), (0, jsx_runtime_1.jsx)("td", { children: "Enterprise" }), (0, jsx_runtime_1.jsx)("td", { children: "8" }), (0, jsx_runtime_1.jsx)("td", { children: "24.99" }), (0, jsx_runtime_1.jsx)("td", { children: "Monthly" }), (0, jsx_runtime_1.jsx)("td", { children: "AUD" }), (0, jsx_runtime_1.jsx)("td", { children: "$800" })] })] })] })] })));
};
exports.default = SampleData;
